import { IJsonQuery } from '@cian/api-models/common/json_query';

import { TReduxActions } from '../../../types/redux';
import { FILTERS_CLEAR_GEO_TYPE } from '../../../constants/action_types';
import { JsonQuery } from '../../../utils/jsonQuery';
import { defaultState } from './defaultState';

export function clearGeoReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_CLEAR_GEO_TYPE:
      return new JsonQuery(jsonQuery)
        .clearGeo()
        .setVillage(undefined)
        .setBSCenters([])
        .getSerializable();
  }

  return jsonQuery;
}
